import axios from "axios";
import {
  chatFeedbackApi,
  fetchDataApi,
  pollyTokenApi,
  starBotAnswerApi,
  submitApi,
  transcribeApi,
  verifyPollyTokenApi,
  generateAudioApi,
  consentApi,
  onboardingApi,
  modelInresponsiveApi,
  middlewareHealthApi,
  saveKBSelectionApi,
  sendTooltipStepStatusApi
} from "../ENV";
import { fetchApi } from "./FetchAPI";
import { getUserApproach, getUserCadre, getUserKb, getUserToken } from "./Utils";

export async function fetchMessages(access_token, offset, fetchDirection) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };
  let params = {}
  if (offset) params["offset"] = offset
  if (fetchDirection) params["fetchdir"] = fetchDirection
  if (getUserCadre()) params["cadre"] = getUserCadre()
  if (getUserKb()) params["kb"] = getUserKb()
  if (getUserApproach()) params["approach"] = getUserApproach()
  const res = await fetchApi(
    fetchDataApi,
    "GET",
    {},
    headerValue,
    params
  );
  return res;
}

export async function submit(access_token, queryObj) {
  var payloadJSON = {...queryObj};
  payloadJSON["cadre"] = getUserCadre()
  payloadJSON["kb"] = getUserKb()
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(
    submitApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}


export async function transcribe(access_token, langaugeCode, audioBlob) {
    try{
      const formData = new FormData();
      // Use a filename so the server treats it as a file upload
      formData.append("file", audioBlob, "audio.mp3");
      formData.append("lang_code", langaugeCode);

      var config = {
        method: "post",
        maxBodyLength: 20 * 1024 * 1024,
        url: transcribeApi,
        headers: {
          "x-access-token": access_token,
          // Let axios set the correct multipart boundary automatically
          "Content-Type": "multipart/form-data"
        },
        data: formData
      };
      const res = await axios(config);
      return res;
    }
    catch(e) {
      return e;
    }
}

export async function getPollyToken(access_token) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(pollyTokenApi, "GET", {}, headerValue, {}, false);
  return res;
}

export async function verifyPollyToken(access_token, pollyToken) {
  var paramsDic = {
    token: pollyToken,
  };
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(
    verifyPollyTokenApi,
    "GET",
    {},
    headerValue,
    paramsDic
  );
  return res.data;
}

export async function generateSpeech(text, langCode, chatId = null) {
  const voice_id = process.env.REACT_APP_AWS_VOICE_ID;
  var headerValue = {
    "Content-type": "application/json",
    "x-access-token": getUserToken()
  };
  var payloadJSON = {
    text: text,
    voice_id: voice_id,
    lang_code: langCode,
  };
  if (chatId) {
    payloadJSON.chat_id = chatId;
  }
  try {
    const res = await fetchApi(generateAudioApi, "POST", JSON.stringify(payloadJSON), headerValue, {}, false);
    if (res?.status === 200) {
      const blob = await res.blob();
      const audioUrl = URL.createObjectURL(blob);
      return {"data": {"url": audioUrl}};
    }
    if (res?.status === 500) {
      return {"data": {"detail": res?.data?.detail || "Unable to generate audio"}};
    }
  } catch(e) {
    return {"data": {"detail": e?.data?.detail || "Unable to generate audio"}};
  }
  
}

// export function generateSpeechText(selectedLanguageCode, audioBlob) {
//     var formData = new FormData();
//     formData.append("file", audioBlob, 'audio-sample.mp3');
//     var config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: speechToTextApi,
//       headers: {
//         "x-lang-code": languageName[selectedLanguageCode],
//         "Content-Type": "audio/mpeg",
//       },
//       data: formData,
//     };

//     return axios(config)
//             .then(res  => {
//               return res.data.text;
//             })
//   }


export async function sendChatFeedback(access_token, chat_block_id, feedback_type, feedback='') {
  var payloadJSON = {
    chat_id: chat_block_id,
    feedback_type: feedback_type,
    feedback: feedback
  };
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(
    chatFeedbackApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}

export async function starBotAnswer(access_token, chat_block_id, starFlag) {
  var payloadJSON = {
    chat_id: chat_block_id,
    starred: starFlag
  };
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(
    starBotAnswerApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );

  return res;
}

export async function saveConsent(access_token, consentFlag, langCode) {
  var payloadJSON = {
    consent: consentFlag,
    cadre: getUserCadre(),
    kb: getUserKb(),
    approach: getUserApproach(),
    language: langCode
  };

  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(consentApi, "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {});
  return res;
}

export async function saveOnboarding(access_token, onboardingFlag, langCode) {
  var payloadJSON = {
    onboarding: onboardingFlag,
    cadre: getUserCadre(),
    kb: getUserKb(),
    approach: getUserApproach(),
    language: langCode
  };

  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(onboardingApi, "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {});
  return res;
}

export async function modelInresponsive(access_token, cadre, kb, approach) {
  var payloadJSON = {
    cadre: cadre,
    kb: kb,
    approach: approach
  };

  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(modelInresponsiveApi, "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {});
  return res;
}

export async function checkMiddleWareHealth() {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json"
  };

  const res = await fetchApi(middlewareHealthApi, "GET", {}, headerValue, {});
  if (res?.status !== 200) {
    if (res?.data?.detail?.dependencies?.model === false) {
        return "modelDown";
      }
    else if (res?.data?.detail?.dependencies?.middleware === false) {
      return "middlewareDown";
    }
    else {
      return "default";
    }
  }
  return null;
}

export async function saveKBSelection(access_token, cadre, kb, approach, langCode) {
  var payloadJSON = {
    cadre: cadre,
    kb: kb,
    approach: approach,
    language: langCode
  };

  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(saveKBSelectionApi, "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {});
  return res;
}

export async function sendTooltipStepStatus(item, status) {
  var payloadJSON = {
    item: item,
    status: status
  };
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": getUserToken()
  };

  const res = await fetchApi(
    sendTooltipStepStatusApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}
